import { PurchaseableSubTier, PurchaseableTier } from '@sparemin/api-sdk';
import { SubscriptionPeriod } from 'blocks/Pricing/types';
import usePlanCost from 'blocks/Pricing/usePlanCost';
import { PREV_GROW_PLAN_MONTHLY_COST } from 'constants/pricing';
import useCost from 'hooks/useCost';
import { isProGrowSubTier } from 'utils/pricing';
import { BillingCyclePlanOptions } from './BillingCycleOptions';
import { PREVIOUS_COSTS_BASIC, PREVIOUS_COSTS_PRO } from './constants';

export type UseBillingCycleCostsConfig = {
  planOptions: BillingCyclePlanOptions;
  period: SubscriptionPeriod;
  tier: PurchaseableTier;
  subtier?: PurchaseableSubTier;
};

export default function useBillingCycleCosts({
  planOptions,
  period,
  tier,
  subtier,
}: UseBillingCycleCostsConfig) {
  const cost = usePlanCost(planOptions[period]);
  const previousProCost = usePlanCost(PREVIOUS_COSTS_PRO[period]);
  const previousBasicCost = usePlanCost(PREVIOUS_COSTS_BASIC[period]);
  // The backend doesn't provide a "previous cost" for the Pro Grow plan,
  // but the UI needs to display one to simulate a promotional discount.
  // To achieve this, we're using a mocked previous cost here.
  const proGrowPreviousCost = useCost(PREV_GROW_PLAN_MONTHLY_COST);
  const isProGrow = isProGrowSubTier(subtier);

  return {
    cost,
    previousCost:
      tier === 'pro' && !isProGrow
        ? previousProCost
        : isProGrow
        ? proGrowPreviousCost
        : previousBasicCost,
  };
}
